import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { withStyles } from './../../../themes/default';
import { Btn } from './../../../components/includes/ui';
import { InputTextField } from './../../../components/includes/ui/input';
import { Loading } from './../../../components/includes/loading';

const styles = theme => ({
  root:          {
                  background: theme.palette.common.white,
                  paddingTop: theme.spacing.unit * 4,
                  paddingBottom: theme.spacing.unit * 4,
                  paddingLeft: theme.spacing.unit * 2,
                  paddingRight: theme.spacing.unit * 2,
                  borderRadius: theme.spacing.unit / 2,
                  border: `1px solid ${ theme.palette.grey[200]}`,
                  boxShadow: theme.shadows[1],
                  position: 'relative',
                  overflow: 'hidden'
                 },
  header:        { marginBottom: theme.spacing.unit * 2 },
  actions:       { textAlign: 'center' }
});

const validate = values => {

  const errors = {};

  if (!values.email) {
    errors.email = "Requerido";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Email inválido";
  }

  if (!values.password) {
    errors.password = "Requerido";
  }

  return errors;

}

class AuthForm extends React.Component {

  render() {

    const { classes, handleSubmit, invalid, hasSubmit }  = this.props;

    return (
      <div className={ classes.root }>

        { hasSubmit && (
          <Loading variant="secondary"/>
        )}

        <form noValidate autoComplete="off" onSubmit={ handleSubmit }>
          <Field
              name="email"
              component={ InputTextField }
              label="Email"
              autoComplete="username"
              type="text"/>
          <Field
              name="password"
              component={ InputTextField }
              label="Password"
              autoComplete={ { 'autoComplete': 'current-password' } }
              type="password"/>
          <div>
            <Btn fullWidth size="large" color="primary" variant="contained" type="submit" disabled={ invalid || hasSubmit }>
              { !hasSubmit ? 'Iniciar sesion' : 'En progreso...' }
            </Btn>
          </div>
        </form>
      </div>
    )
  }
}

AuthForm = reduxForm({
  form: 'AuthForm',
  validate
})(AuthForm);

export default withStyles(styles)(AuthForm);
